import React from 'react'

import {
  Icon, CloseTagFilled, SuccessFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool, arrayOf, shape, func } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function DropdownItem({
  title,
  features,
  showAiContactNote = false,
  locale = 'en',
  onLicenseClick: handleLicenseClick,
}) {
  const showFeatures = features.length > 0
  const aiContactNoteQuestion = i18n.t('itemPage.licenseDropdown.aiContactNote.question', { ns: 'rails', lng: locale })
  const aiContactNoteLinkText = i18n.t('itemPage.licenseDropdown.aiContactNote.linkText', { ns: 'rails', lng: locale })

  return (
    <div className="license-dropdown-item">
      <span className="license-dropdown__label">
        {title}
      </span>
      <div className="license-dropdown-item__description">
        {showFeatures && features.map(({ isActive, description, title: featureTitle }) => {
          return (
            <div key={description} className="license-dropdown-item__feature">
              <div className="license-dropdown-item__feature-text">
                <h4 className="license-dropdown-item__feature-text-title">{featureTitle}</h4>
                <span className="license-dropdown-item__feature-text-description">{description}</span>
              </div>
              <Icon
                svgComponent={isActive ? SuccessFilled : CloseTagFilled}
                color={isActive ? 'primary' : 'warning'}
                size="small"
              />
            </div>
          )
        })}
        {showAiContactNote && (
          <p className="license-dropdown-item__ai-contact-note cgt-body-base">
            {aiContactNoteQuestion}{' '}
            <a href="https://www.cgtrader.com/discover/datasets" className="license-dropdown-item__ai-contact-link">
              {aiContactNoteLinkText}
            </a>
          </p>
        )}
        {' '}
        <p className="license-dropdown-item__description-link" onClick={handleLicenseClick}>
          More about this license
        </p>
      </div>
    </div>
  )
}

DropdownItem.propTypes = {
  title: string.isRequired,
  features: arrayOf(shape({
    description: string.isRequired,
    isActive: bool.isRequired,
    title: string.isRequired,
    link: string,
  })).isRequired,
  showAiContactNote: bool,
  locale: string,
  onLicenseClick: func.isRequired,
}

export default DropdownItem
